import { render, staticRenderFns } from "./Todaysgoal.vue?vue&type=template&id=b6bb7cba&scoped=true&"
import script from "./Todaysgoal.vue?vue&type=script&lang=js&"
export * from "./Todaysgoal.vue?vue&type=script&lang=js&"
import style0 from "./Todaysgoal.vue?vue&type=style&index=0&id=b6bb7cba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6bb7cba",
  null
  
)

export default component.exports